var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Collapse from 'antd/lib/collapse';
import Row from 'antd/lib/row';
import Col from 'antd/lib/col';
import Radio from 'antd/lib/radio';
import Switch from 'antd/lib/switch';
import Tooltip from 'antd/lib/tooltip';
import { Icon as AntIcon } from '@ant-design/compatible';
import { polyfill } from 'react-lifecycles-compat';
import Icon from './common/Icon';
import AutoComplete from './common/AutoComplete';
import Color from './common/Color';
var Panel = Collapse.Panel;
var RadioButton = Radio.Button;
var RadioGroup = Radio.Group;
var EditorShadow = /** @class */ (function (_super) {
    __extends(EditorShadow, _super);
    function EditorShadow(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (key, v, isDrag) {
            var _a, _b;
            var keyValue = __assign(__assign({}, _this.defaultShadow), (_a = {}, _a[key] = v, _a));
            var value = _this.props.value;
            var mValue = __assign({}, value);
            mValue[_this.state.key][key] = v;
            Object.keys(keyValue).forEach(function ($key) {
                if (!mValue[_this.state.key][$key]) {
                    mValue[_this.state.key][$key] = keyValue[$key];
                }
            });
            _this.props.onChange('shadow', mValue, isDrag);
            _this.setState({
                open: __assign(__assign({}, _this.state.open), (_b = {}, _b[_this.state.key] = true, _b)),
            });
        };
        _this.getTabs = function () { return (React.createElement(RadioGroup, { value: _this.state.key, onChange: _this.radioChange, size: "small" }, Object.keys(_this.props.locale.tags).map(function (key) { return (React.createElement(RadioButton, { value: key, key: key, className: "ant-radio-button-auto-width" }, _this.props.locale.tags[key])); }))); };
        _this.openChange = function (e) {
            var _a, _b;
            var _c = _this.state, open = _c.open, key = _c.key;
            var value = __assign(__assign({}, _this.props.value), (_a = {}, _a[key] = e ? __assign({}, _this.defaultShadow) : 'none', _a));
            _this.props.onChange('shadow', value);
            _this.setState({
                open: __assign(__assign({}, open), (_b = {}, _b[key] = e, _b)),
            });
        };
        _this.radioChange = function (e) {
            _this.setState({
                key: e.target.value,
            });
        };
        _this.defaultShadow = {
            x: '5px',
            y: '5px',
            blur: '5px',
            color: 'rgba(0,0,0,0.35)',
        };
        _this.state = {
            key: 'boxShadow',
            open: {
                boxShadow: !!Object.keys(props.value.boxShadow).length,
                textShadow: !!Object.keys(props.value.textShadow).length,
            },
        };
        return _this;
    }
    EditorShadow.getDerivedStateFromProps = function (props, _a) {
        var prevProps = _a.prevProps;
        var nextState = {
            prevProps: props,
        };
        if (prevProps && prevProps.value !== props.value) {
            var boxShadow = props.value.boxShadow !== 'none' &&
                !!Object.keys(props.value.boxShadow).length;
            var textShadow = props.value.textShadow !== 'none' &&
                !!Object.keys(props.value.textShadow).length;
            nextState.open = {
                boxShadow: boxShadow,
                textShadow: textShadow,
            };
        }
        return nextState;
    };
    EditorShadow.prototype.render = function () {
        var _this = this;
        var _a = this.props, value = _a.value, locale = _a.locale, onChange = _a.onChange, props = __rest(_a, ["value", "locale", "onChange"]);
        var _b = this.state, key = _b.key, open = _b.open;
        return (React.createElement(Panel, __assign({}, props, { header: props.header || locale.header }),
            this.getTabs(),
            React.createElement("div", { key: key, style: { marginTop: 10 } },
                React.createElement(Row, { gutter: 8 },
                    React.createElement(Col, { span: 6 }, locale.switch),
                    React.createElement(Col, { span: 6 },
                        React.createElement(Switch, { size: "small", checked: open[key], onChange: this.openChange })),
                    React.createElement(Col, { span: 6 }, locale.inner),
                    React.createElement(Col, { span: 6 },
                        React.createElement(Switch, { size: "small", checked: open[key] ? !!value[key].inset : false, onChange: function (e) {
                                _this.onChange('inset', e ? 'inset' : null);
                            } }))),
                React.createElement(Row, { gutter: 8 },
                    React.createElement(Col, { span: 3 },
                        React.createElement(Icon, { type: "offset", prompt: locale.offset })),
                    React.createElement(Col, { span: 9 },
                        React.createElement(AutoComplete, { style: { width: '100%' }, placeholder: "offset x", value: open[key] ? value[key].x : '', onChange: function (e) {
                                _this.onChange('x', e);
                            } })),
                    React.createElement(Col, { span: 9 },
                        React.createElement(AutoComplete, { style: { width: '100%' }, placeholder: "offset y", value: open[key] ? value[key].y : '', onChange: function (e) {
                                _this.onChange('y', e);
                            } })),
                    React.createElement(Col, { span: 3 },
                        React.createElement(Tooltip, { placement: "topRight", arrowPointAtCenter: true, title: locale.offset_help },
                            React.createElement(AntIcon, { type: "question-circle" })))),
                React.createElement(Row, { gutter: 8 },
                    React.createElement(Col, { span: 3 },
                        React.createElement(Icon, { type: "blur", prompt: locale.blur })),
                    React.createElement(Col, { span: 9 },
                        React.createElement(AutoComplete, { style: { width: '100%' }, placeholder: "blur", value: open[key] ? value[key].blur : '', onChange: function (e) {
                                _this.onChange('blur', e);
                            } })),
                    this.state.key === 'boxShadow' && ([
                        React.createElement(Col, { span: 3, key: "spread-icon" },
                            React.createElement(Icon, { type: "spread", prompt: locale.spread })),
                        React.createElement(Col, { span: 9, key: "1" },
                            React.createElement(AutoComplete, { style: { width: '100%' }, placeholder: "spread", value: open[key] ? value[key].spread : '', onChange: function (e) {
                                    _this.onChange('spread', e);
                                } })),
                    ])),
                React.createElement(Color, { color: open[key] ? value[key].color : '', onChange: function (e, isDrag) {
                        _this.onChange('color', e, isDrag);
                    }, title: React.createElement(Icon, { type: "bg-colors", prompt: locale.color }) }))));
    };
    EditorShadow.propTypes = {
        value: PropTypes.object,
        onChange: PropTypes.func,
        header: PropTypes.string,
        locale: PropTypes.object,
    };
    EditorShadow.defaultProps = {
        value: {
            boxShadow: {},
            textShadow: {},
        },
        onChange: function () {
        },
    };
    return EditorShadow;
}(Component));
EditorShadow.componentName = 'EditorShadow';
export default polyfill(EditorShadow);
